import type { GameState, Piece, SquareKey } from "../../src/engine";
import type { WireGameState } from "./protocol";

export function toWire(state: GameState): WireGameState {
  return {
    board: Array.from(state.board.entries()),
    toMove: state.toMove,
    captured: { white: [...state.captured.white], black: [...state.captured.black] },
    turnNumber: state.turnNumber,
    victoryConfig: { ...state.victoryConfig },
    victory: state.victory ? { ...state.victory } : null,
    history: [...state.history],
  };
}

export function fromWire(wire: WireGameState): GameState {
  const board = new Map<SquareKey, Piece>(wire.board as Array<[SquareKey, Piece]>);
  return {
    board,
    toMove: wire.toMove,
    captured: { white: [...wire.captured.white], black: [...wire.captured.black] },
    turnNumber: wire.turnNumber,
    victoryConfig: { ...wire.victoryConfig },
    victory: wire.victory ? { ...wire.victory } : null,
    history: [...wire.history],
  };
}
